import { useNavigate } from "react-router-dom"; 
import '../../../../../styles/typography.css';

import SimpleTable from "../../../../../components/atoms/table/simpleTable/simpleTable";
import Button from "../../../../../components/atoms/button/Button";
import { formatDate } from "../../../../../utility/Formatdate";

const columns = [
  "Sample ID",
  "Product",
  "Company",
  "Date",
  "Unit",
  "Exp Level",
  "Low Limit",
  "Up Limit",
  "Result",
];

const FinalView = ({ data = [] }) => {
  const navigate = useNavigate();


  const tableData = (data || []).map((item) => ({
    "Sample ID": item.sampleID,
    "Product": item.productName,
    "Company": item.companyName,
    "Date": item.createdDate ? formatDate(item.createdDate) : "",
    "Unit": item.unit,
    "Exp Level": item.expLevel !== undefined && item.expLevel !== null && !isNaN(item.expLevel)
      ? item.expLevel.toString()
      : "",
    "Low Limit":
      item.lowLimit !== undefined && item.lowLimit !== null && !isNaN(item.lowLimit)
        ? item.lowLimit.toString()
        : "",
    "Up Limit":
      item.upLimit !== undefined && item.upLimit !== null && !isNaN(item.upLimit)
        ? item.upLimit.toString()
        : "",
    "Result":
      item.result !== undefined && item.result !== null && !isNaN(item.result)
        ? item.result.toString()
        : "",
  }));

  return (
    <div>
      <SimpleTable
        title={<span className="header-default-style">Final Review</span>}
        columns={columns}
        data={tableData}
        scrollable={true}
        scrollHeight="200px"
        rowsPerPage={5}
        headerActions={
          <Button
            variant="outlined"
            size="sm"
            onClick={() => navigate("/tasks")}
            title="View All"
          >
            View All
          </Button>
        }
      />
    </div>
  );
};

export default FinalView;
